import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { NotificationBell } from "@/components/NotificationBell";

const scrollTo = (hash) => {
  if (window.__lenis) window.__lenis.scrollTo(hash, { offset: -70 });
  else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src="/logo-mark.png" alt="MetrixWorks logo" className="h-10 w-10 bg-white p-0.5" data-testid="nav-logo-image" />
          <span className="flex items-baseline gap-2">
            <span className="font-display text-xl tracking-tight text-white">MetrixWorks</span>
            <span className="font-accent text-[10px] tracking-[0.25em] text-[#D4AF37] uppercase hidden sm:inline">Service Pvt Ltd</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-10 font-accent text-[11px] tracking-[0.2em] uppercase text-white/60">
          <button data-testid="nav-plans-link" onClick={() => scrollTo("#plans")} className="hover:text-[#D4AF37] transition-colors">Plans</button>
          <button data-testid="nav-manifesto-link" onClick={() => scrollTo("#manifesto")} className="hover:text-[#D4AF37] transition-colors">Manifesto</button>
          <button data-testid="nav-contact-link" onClick={() => scrollTo("#contact")} className="hover:text-[#D4AF37] transition-colors">Contact</button>
        </nav>
        <div className="flex items-center gap-4">
          {user ? (
            <>
              {user.role !== "admin" && <NotificationBell />}
              <Link
                data-testid="nav-portal-link"
                to={user.role === "admin" ? "/admin" : "/dashboard"}
                className="font-accent text-[11px] tracking-[0.2em] uppercase text-white/70 hover:text-[#D4AF37] transition-colors"
              >
                {user.role === "admin" ? "Admin" : "My Portfolio"}
              </Link>
              <button
                data-testid="nav-logout-button"
                onClick={handleLogout}
                className="border border-white/20 text-white/70 px-4 py-2 font-accent text-[11px] tracking-[0.2em] uppercase hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link data-testid="nav-login-link" to="/login" className="font-accent text-[11px] tracking-[0.2em] uppercase text-white/70 hover:text-[#D4AF37] transition-colors">
                Login
              </Link>
              <Link
                data-testid="nav-get-started-button"
                to="/register"
                className="border border-[#D4AF37] text-[#D4AF37] px-4 py-2 font-accent text-[11px] tracking-[0.2em] uppercase hover:bg-[#D4AF37] hover:text-black transition-colors"
              >
                Start Investing
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};
